<div class="externe-daten">
  @if (bauprojekt) {
    <cap-content-header>
      <cap-title>
        {{ "GWRBauprojekt" | translate }}: {{ bauprojekt.beschreibung | substring: 100 }} EPROID: {{ bauprojekt.eproid.value }}
      </cap-title>
    </cap-content-header>
  }

  @if (bauprojekt) {
    <div class="row mt-2">
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement [value]="bauprojekt.beschreibung" label="Beschreibung"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="bauprojekt.gemeinde.name" label="Gemeinde"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="bauprojekt.amtlicheBaudossiernummer" label="AmtlicheBaudossiernummer"></cap-kopfdatenelement>
        <cap-kopfdatenelement
          [value]="bauprojekt.amtlicheBaudossiernummerZusatz.toString()"
          label="AmtlicheBaudossiernummerZusatz"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="bauprojekt.projektstatus | translate" label="Projektstatus"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="bauprojekt.bauwerkeTyp | translate" label="TypDerBauwerke"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="bauprojekt.bauwerkeArt | translate" label="ArtDerBauwerke"></cap-kopfdatenelement>
      </div>
      <div class="col-md-6 col-sm-12">
        <cap-kopfdatenelement [value]="bauprojekt.eproid.value.toString()" label="EPROID"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="bauprojekt.datumBaueingabe | datum" label="DatumProjekteingabe"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="bauprojekt.datumBaubewilligung | datum" label="DatumBaubewilligung"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="bauprojekt.datumBaubeginn | datum" label="DatumBaubeginn"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="bauprojekt.datumBauende | datum" label="DatumBauende"></cap-kopfdatenelement>
        <cap-kopfdatenelement [value]="[bauprojekt.baudauer] + monate" label="VoraussichtlicheBaudauer"></cap-kopfdatenelement>
        <cap-kopfdatenelement [showZeroValue]="true" [value]="bauprojekt.anzahlGebaeude" label="AnzahlGebaeude"></cap-kopfdatenelement>
        <cap-kopfdatenelement [showZeroValue]="true" [value]="bauprojekt.anzahlWohnungen" label="AnzahlWohnungen"></cap-kopfdatenelement>
      </div>
    </div>
    <cap-gwr-gebaeude-table [listLoader]="gebaeudeListLoader" [showTotal]="false" [showZeilenSelect]="false">
      <div class="title-divider" name="title">
        <h2>{{ "BetroffeneGebäude" | translate }}</h2>
      </div>
    </cap-gwr-gebaeude-table>
    <cap-gwr-grundstueck-table [listLoader]="grundstueckListLoader">
      <div class="title-divider" name="title">
        <h2>{{ "BetroffeneGrundstücke" | translate }}</h2>
      </div>
    </cap-gwr-grundstueck-table>
  } @else {
    <cap-spinner-small [withBreadcrumb]="true"></cap-spinner-small>
  }
</div>
